import React, { PureComponent } from 'react';
import Tooltip from '../tooltip';
import boundingBoxClientRect from 'bounding-client-rect';
import { clusterAcronyms } from '../../reducers/projects';
import styles from './bubble-chart.scss';
import Button from '../button';

class ChartTooltip extends PureComponent {
  renderButton() {
    const { project } = this.props;
    return project.link ? (
      <Button
        link={project.link}
        gaEvent={{
          event: 'Project learn more click',
          params: { event_label: project.name },
        }}
      />
    ) : (
      ''
    );
  }

  renderSubtitle() {
    const { project } = this.props;
    return project.subtitle ? (
      <div className={`${styles.tooltipInfo} ${styles.tooltipInfoDark}`}>
        {project.subtitle}
      </div>
    ) : null;
  }

  renderClusterName() {
    const { project, tab } = this.props;
    return tab === 'By Priority' ? (
      <p className={`${styles.tooltipInfo} ${styles.tooltipInfoDark}`}>
        Cluster: {clusterAcronyms[project.cluster]}
      </p>
    ) : null;
  }

  render() {
    const { circleNode, project, canvasId } = this.props;
    const canvasElement = document.getElementById(canvasId);
    if (!project || !canvasElement) return <div />;
    const canvasRect = boundingBoxClientRect(canvasElement);
    const rect = boundingBoxClientRect(circleNode);
    const top = rect.top - canvasRect.top;
    const left = rect.left - canvasRect.left + rect.width / 2;

    return (
      <Tooltip
        isVisible={true}
        top={top}
        left={left}
        onMouseEnter={this.props.onTooltipOver}
        onMouseLeave={this.props.onTooltipLeave}
      >
        <div>
          <div className={styles.tooltipContent}>
            <h3 className={styles.tooltipHeading}>{project.name}</h3>
            {this.renderSubtitle()}
            {this.renderClusterName()}
            {this.renderButton()}
          </div>
        </div>
      </Tooltip>
    );
  }
}

export default ChartTooltip;



// WEBPACK FOOTER //
// ./src/components/bubble-chart/chart-tooltip.js